<template>
  <div id="contenedor-registrar-nuevo-contrato">
    <v-form v-model="formularioValido" ref="registrarNuevoContrato">
      <v-row>
        <!-- Generales del contrato -->
        <v-col cols="12" md="8" class="pa-1">
          <v-card flat>
            <v-card-text>
              <v-row align="center" justify="space-between">
                <v-col cols="12" md="4">
                  <v-switch
                    v-model="contrato.esObraFinanciada"
                    inset
                    color="success"
                    label="¿Es obra Financiada?"
                  >
                  </v-switch>
                </v-col>
                <custom-text-field
                  cols="12"
                  md="4"
                  v-model="contrato.numero"
                  label="Número"
                  :rules="[mixReglas.requerido]"
                >
                </custom-text-field>
                <custom-autocomplete
                  cols="12"
                  md="4"
                  v-model="contrato.comoSeContrato"
                  label="¿Cómo se Contrató?"
                  :items="tiposContratos"
                  item-text="text"
                  item-value="id"
                  clearable
                  :rules="[mixReglas.requerido]"
                >
                </custom-autocomplete>
                <custom-autocomplete
                  cols="12"
                  md="11"
                  v-model="contrato.idContratista"
                  label="Contratista"
                  :items="contratistas"
                  item-text="nombreRazonSocial"
                  item-value="id"
                  clearable
                  :rules="[mixReglas.requerido]"
                >
                </custom-autocomplete>
                <v-col cols="1">
                  <registrar-nuevo-contratista
                    ref="registrarNuevoContratista"
                    only-icon
                  >
                  </registrar-nuevo-contratista>
                </v-col>
                <custom-text-area
                  cols="12"
                  v-model="contrato.meta"
                  label="Objeto"
                  rows="4"
                  :rules="[mixReglas.requerido]"
                >
                </custom-text-area>
              </v-row>
              <v-row justify="space-between">
                <custom-date-picker
                  cols="12"
                  md="3"
                  v-model="contrato.fecha"
                  label="Fecha Contrato"
                  :rules="[mixReglas.requerido]"
                >
                </custom-date-picker>
                <custom-date-picker
                  cols="12"
                  md="3"
                  v-model="contrato.fechaInicio"
                  label="Fecha Inicio"
                  :rules="[mixReglas.requerido]"
                >
                </custom-date-picker>
                <custom-date-picker
                  cols="12"
                  md="3"
                  v-model="contrato.fechaTermino"
                  label="Fecha Termino"
                  :rules="[mixReglas.requerido]"
                >
                </custom-date-picker>
                <custom-text-field
                  v-model.number="contrato.plazo"
                  cols="12"
                  md="2"
                  readonly
                  label="Plazo"
                  suffix="días"
                >
                </custom-text-field>
              </v-row>
              <v-divider></v-divider>
              <v-col cols="12" md="4">
                <v-switch
                  v-model="seleccionarObras"
                  @change="cambioCapturaObras"
                  inset
                  color="success"
                  label="¿Seleccionar Obras?"
                >
                </v-switch>
              </v-col>
              <!-- Seleccionador de obras -->
              <template v-if="seleccionarObras">
                <v-col cols="12">
                  <v-divider class="mb-4"> </v-divider>
                  <obras-picker
                    :obrasContratos="this.obrasContratos"
                    v-model="obras"
                  >
                  </obras-picker>
                </v-col>
              </template>
              <!-- Captura de obra desde contrato -->
              <template v-else>
                <agregar-obra desde-contrato :obra="obra"> </agregar-obra>
              </template>
              <v-list two-line dense>
                <v-list-item
                  v-for="(obra, index) in obras"
                  :key="`obra-${obra.id}`"
                >
                  <v-list-item-action>
                    <v-chip>
                      {{ index + 1 }}
                    </v-chip>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ obra.clave }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ obra.meta }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <custom-text-field-green
                      v-model.number="obra.importe"
                      label="Importe"
                      prefix="$"
                      :value="0"
                      type="number"
                      @keyup="sumarImportesObras"
                    >
                    </custom-text-field-green>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
              <v-row v-if="obras.length > 1">
                <v-col cols="auto" class="py-0">
                  <v-checkbox
                    v-model="contrato.seEjecutaraPorSeparado"
                    hide-details
                    color="secondary"
                    class="my-0"
                  >
                    <template v-slot:label>
                      <span class="secondary--text">Ejecutar por separado</span>
                    </template>
                  </v-checkbox>
                </v-col>
              </v-row>
              <v-divider class="mt-2"></v-divider>
              <!-- Sancion y Retencion -->
              <v-row>
                <v-col>
                  <v-row justify="center">
                    <h3 class="base6--text">Sanción</h3>
                  </v-row>
                  <v-row justify="space-between" align="center">
                    <v-radio-group
                      cols="8"
                      v-model="contrato.periodicidadSancion"
                      label="Periodicidad de sanción"
                      mandatory
                    >
                      <v-radio value="diaria">
                        <template v-slot:label>
                          <div>
                            <strong class="secondary--text">Diaria</strong>
                          </div>
                        </template>
                      </v-radio>
                      <v-radio value="mensual">
                        <template v-slot:label>
                          <div>
                            <strong class="secondary--text">Mensual</strong>
                          </div>
                        </template>
                      </v-radio>
                    </v-radio-group>
                    <custom-text-field
                      cols="4"
                      v-model.number="contrato.porcentajeSancion"
                      label="% Sanción"
                    >
                    </custom-text-field>
                  </v-row>
                </v-col>
                <v-divider vertical></v-divider>
                <v-col>
                  <v-row justify="center">
                    <h3 class="base6--text">Retención</h3>
                  </v-row>
                  <v-row justify="space-between" align="center">
                    <v-radio-group
                      cols="8"
                      v-model="contrato.tipoRetencion"
                      label="Tipo de Retención"
                      mandatory
                    >
                      <v-radio value="baseDias">
                        <template v-slot:label>
                          <div>
                            <strong class="secondary--text"
                              >Por días de atraso</strong
                            >
                          </div>
                        </template>
                      </v-radio>
                      <v-radio value="baseMonto">
                        <template v-slot:label>
                          <div>
                            <strong class="secondary--text"
                              >Por monto de atraso</strong
                            >
                          </div>
                        </template>
                      </v-radio>
                    </v-radio-group>
                    <custom-text-field
                      cols="4"
                      v-model.number="contrato.porcentajeRetencion"
                      label="% Retención"
                    >
                    </custom-text-field>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <!-- Monto del contrato -->
        <v-col cols="12" md="4" class="pa-1">
          <v-card dense>
            <v-card-title class="base6--text">
              Monto del contrato
            </v-card-title>
            <v-card-text>
              <v-row>
                <template v-if="contrato.esObraFinanciada">
                  <custom-text-field-green
                    cols="12"
                    v-model.number="contrato.importeCostoDirecto"
                    label="Importe Costo Directo"
                    es-dinero
                    prefix="$"
                    :rules="[mixReglas.requerido]"
                    @keyup="sumarImportesObrasFinanciada"
                  >
                  </custom-text-field-green>
                  <custom-text-field-green
                    cols="5"
                    v-model.number="contrato.porcentajeCostoIndirectos"
                    label="% Indirectos"
                    :rules="[mixReglas.requerido]"
                  >
                  </custom-text-field-green>
                  <custom-text-field-green
                    cols="7"
                    v-model.number="contrato.importeCostoIndirectos"
                    label="Importe Indirectos"
                    es-dinero
                    prefix="$"
                    :rules="[mixReglas.requerido]"
                    @keyup="sumarImportesObrasFinanciada"
                  >
                  </custom-text-field-green>
                  <custom-text-field-green
                    cols="5"
                    v-model.number="contrato.porcentajeUtilidad"
                    label="% Utilidad"
                    :rules="[mixReglas.requerido]"
                  >
                  </custom-text-field-green>
                  <custom-text-field-green
                    cols="7"
                    v-model.number="contrato.importeUtilidad"
                    label="Importe Utilidad"
                    es-dinero
                    prefix="$"
                    :rules="[mixReglas.requerido]"
                    @keyup="sumarImportesObrasFinanciada"
                  >
                  </custom-text-field-green>
                  <custom-text-field-green
                    cols="5"
                    v-model.number="contrato.porcentajeCargosAdicionales"
                    label="% Adicionales"
                    :rules="[mixReglas.requerido]"
                  >
                  </custom-text-field-green>
                  <custom-text-field-green
                    cols="7"
                    v-model.number="contrato.importeCargosAdicionales"
                    label="Importe Adicionales"
                    es-dinero
                    prefix="$"
                    :rules="[mixReglas.requerido]"
                    @keyup="sumarImportesObrasFinanciada"
                  >
                  </custom-text-field-green>
                  <custom-text-field-green
                    cols="5"
                    v-model.number="contrato.porcentajeCostoFinanciero"
                    label="% C. Financiero"
                    :rules="[mixReglas.requerido]"
                  >
                  </custom-text-field-green>
                  <custom-text-field-green
                    cols="7"
                    v-model.number="contrato.importeCostoFinanciero"
                    label="Importe C. Financiero"
                    es-dinero
                    prefix="$"
                    :rules="[mixReglas.requerido]"
                    @keyup="sumarImportesObrasFinanciada"
                  >
                  </custom-text-field-green>
                  <v-col cols="12">
                    <v-divider></v-divider>
                  </v-col>
                </template>
                <custom-text-field-green
                  cols="12"
                  v-model.number="contrato.importe"
                  label="Importe"
                  es-dinero
                  prefix="$"
                  :rules="[mixReglas.requerido, reglas.mayorCero]"
                  @keyup="calcularTotal"
                >
                </custom-text-field-green>
                <custom-text-field-green
                  cols="12"
                  md="4"
                  v-model.number="contrato.porcentajeIva"
                  label="% I.V.A."
                  suffix="%"
                  es-dinero
                  :rules="[mixReglas.requerido]"
                  @keyup="calcularTotal"
                >
                </custom-text-field-green>
                <custom-text-field-green
                  cols="12"
                  md="8"
                  v-model="contrato.iva"
                  label="Importe I.V.A."
                  prefix="$"
                  es-dinero
                  readonly
                  disabled
                >
                </custom-text-field-green>
                <custom-text-field-green
                  cols="12"
                  v-model="contrato.total"
                  es-dinero
                  label="Total"
                  prefix="$"
                  readonly
                  disabled
                >
                </custom-text-field-green>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import RegistrarNuevoContratista from '@/components/administracion/configuracion/catalogos/contratistas/Nuevo.vue';
import AgregarObra from '@/components/administracion/obras/basico/Nueva.vue';
import CustomAutocomplete from '@/components/inputs/Autocomplete.vue';
// import CustomSelect from '@/components/inputs/Select.vue';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomTextFieldGreen from '@/components/inputs/TextFieldGreen.vue';
import CustomTextArea from '@/components/inputs/TextArea.vue';
import CustomDatePicker from '@/components/inputs/DatePicker.vue';
import ObrasPicker from '@/components/ObrasPicker.vue';
import mixContratos from './mixContratos';

export default {
  name: 'RegistrarNuevoContrato',
  mixins: [mixContratos],
  props: {
    obrasContratos: {
      type: Array,
      required: true,
    },
  },
  components: {
    RegistrarNuevoContratista,
    CustomAutocomplete,
    // CustomSelect,
    CustomTextField,
    CustomTextFieldGreen,
    CustomTextArea,
    CustomDatePicker,
    ObrasPicker,
    AgregarObra,
  },
  data() {
    return {
      seleccionarObras: false,
      mostrarVentanaRegistrarNuevoContratista: false,
      contratistaSelected: null,
      formularioValido: false,
      enviandoFormulario: false,
      reglas: {
        mayorCero: (val) => {
          const valor = Number(String(val).replace(/\D/g, ''));
          return valor > 0 || 'El monto debe de ser mayor a 0.';
        },
      },
      contrato: {
        idContratista: null, // ! String
        // idLicitacion, // String
        // idAdjudicacionDirecta, // String
        seEjecutaraPorSeparado: false, // Boolean
        esObraFinanciada: false,
        comoSeContrato: null, // ! String
        numero: null, // ! String
        ejercicio: Number(new Date().toISOString().substr(0, 4)), // ! Int
        periodo: 1,
        fecha: new Date().toISOString().substr(0, 10), // ! String
        meta: null, // ! String
        importeCostoDirecto: 0,
        porcentajeCostoIndirectos: 0,
        importeCostoIndirectos: 0,
        porcentajeUtilidad: 0,
        importeUtilidad: 0,
        porcentajeCargosAdicionales: 0,
        importeCargosAdicionales: 0,
        porcentajeCostoFinanciero: 0,
        importeCostoFinanciero: 0,
        importe: 0, // ! Double
        porcentajeIva: 16, // ! Int
        iva: 0, // ! Double
        total: 0, // ! Double
        fechaInicio: new Date().toISOString().substr(0, 10), // ! String
        fechaTermino: new Date().toISOString().substr(0, 10), // ! String
        plazo: 1, // ! Int
        periodicidadSancion: 'diaria', // ! String
        porcentajeSancion: 1, // ! Double
        tipoRetencion: 'baseDias', // ! String
        porcentajeRetencion: 0.5, // ! Double
        normatividad: 1, // ! Int
        obras: [],
      },
      obras: [],
      tiposContratos: [
        { id: 'LP', text: 'LICITACIÓN PÚBLICA' },
        { id: 'LI', text: 'LICITACIÓN RESTINGIDA POR INVITACIÓN' },
        { id: 'AD', text: 'ADJUDICACION DIRECTA' },
      ],
      ejercicios: [],
      obra: {
        idPrograma: '', // (Catalogo)
        idTipo: '', // (Catalogo)
        idSubtipo: '', // (Catalogo)
        ejercicio: 0,
        clave: '',
        meta: '',
        ubicacion: {
          idMunicipio: 'bb1d2835-b403-41dc-b9f3-dcb9b2489c89', // (Catalogo)
          ubicacion: '',
          localidad: '',
          cabeceraMunicipial: false,
        },
        impacto: {
          beneficiados: 0,
          metaFisica: 0,
          metaFisicaUnidad: '',
          justificacionTecnica: '',
          justificacionSocial: '',
          problematica: '',
          avanceFisicoActual: 0, // Float
          avanceProgramadoCierre: 0, // Float
          descripcionTotalObra: '',
          conceptosEjecutar: '',
        },
      },
    };
  },
  methods: {
    cambioCapturaObras() {
      if (!this.seleccionarObras) {
        this.obras = [];
      }
    },
    limpiarFormulario() {
      this.$refs.registrarNuevoContrato.reset();
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
  },
  computed: {
    fechaInicio() {
      return this.contrato.fechaInicio;
    },
    fechaTermino() {
      return this.contrato.fechaTermino;
    },
  },
  watch: {
    contrato: {
      handler(contrato) {
        this.obra.clave = contrato.numero;
        this.obra.ejercicio = contrato.ejercicio;
        this.obra.meta = contrato.meta;
      },
      deep: true,
    },
    formularioValido: {
      handler(valor) {
        this.$emit('formularioValido', valor);
      },
    },
    enviandoFormulario: {
      handler(valor) {
        this.$emit('enviandoFormulario', valor);
      },
    },
    fechaInicio() {
      this.setPlazo();
    },
    fechaTermino() {
      this.setPlazo();
    },
    'contrato.importe': {
      handler() {
        this.calcularTotal();
      },
    },
  },
};
</script>

<style lang="scss">
</style>
